import { alpha, darken } from '@mui/material/styles';
import { isLightTheme, resolveSemanticColor } from '@/theme/semanticTokens';
import { s, typographyTokens } from '@/theme/tokens';
import type { TooltipProps } from '@/ui';

export const RELATIVE_TIME_TEXT_SX = {
  display: 'block',
  width: '100%',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export const SUITE_NAME_TO_TAGS_GAP = s('none');

export const LATEST_META_DETAIL_ROW_SX = {
  display: 'flex',
  alignItems: 'center',
  gap: s('xs'),
  pl: s('xxs'),
  width: '100%',
  minWidth: 0,
  overflow: 'hidden',
};

export const LATEST_META_DETAIL_VALUE_SX = {
  display: 'block',
  minWidth: 0,
  flex: 1,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const LATEST_META_DETAIL_TEXT_SX = {
  '&&': {
    fontSize: '13px',
    fontWeight: typographyTokens.captionSmall.fontWeight,
    lineHeight: 1.05,
  },
};

export const CLONE_TOOLTIP_SLOT_PROPS: TooltipProps['slotProps'] = {
  tooltip: {
    sx: {
      fontSize: '15px',
      lineHeight: 1.4,
    },
  },
};

export const resolveLatestChipForeground = (
  theme: Parameters<typeof resolveSemanticColor>[0],
  statusTone: string,
): string => {
  if (isLightTheme(theme)) {
    if (statusTone === 'green' || statusTone === 'success') {
      return darken(resolveSemanticColor(theme, 'success'), 0.5);
    }
    if (statusTone === 'red' || statusTone === 'error') {
      return darken(resolveSemanticColor(theme, 'error'), 0.5);
    }
    if (statusTone === 'orange' || statusTone === 'warning' || statusTone === 'brown') {
      return darken(resolveSemanticColor(theme, 'warning'), 0.52);
    }
    return darken(resolveSemanticColor(theme, 'textPrimary'), 0.24);
  }
  if (statusTone === 'green' || statusTone === 'success') {
    return darken(resolveSemanticColor(theme, 'success'), 0.72);
  }
  if (statusTone === 'red' || statusTone === 'error') {
    return darken(resolveSemanticColor(theme, 'error'), 0.72);
  }
  if (statusTone === 'orange' || statusTone === 'warning' || statusTone === 'brown') {
    return darken(resolveSemanticColor(theme, 'warning'), 0.74);
  }
  return darken(resolveSemanticColor(theme, 'textPrimary'), 0.56);
};

export const resolveLatestChipBackground = (
  theme: Parameters<typeof resolveSemanticColor>[0],
  statusTone: string,
): string => {
  if (isLightTheme(theme)) {
    if (statusTone === 'green' || statusTone === 'success') {
      return alpha(resolveSemanticColor(theme, 'success'), 0.34);
    }
    if (statusTone === 'red' || statusTone === 'error') {
      return alpha(resolveSemanticColor(theme, 'error'), 0.32);
    }
    if (statusTone === 'orange' || statusTone === 'warning' || statusTone === 'brown') {
      return alpha(resolveSemanticColor(theme, 'warning'), 0.34);
    }
    return alpha(resolveSemanticColor(theme, 'surfaceSubtle'), 0.72);
  }
  if (statusTone === 'green' || statusTone === 'success') {
    return darken(resolveSemanticColor(theme, 'success'), 0.23);
  }
  if (statusTone === 'red' || statusTone === 'error') {
    return darken(resolveSemanticColor(theme, 'error'), 0.23);
  }
  if (statusTone === 'orange' || statusTone === 'warning' || statusTone === 'brown') {
    return darken(resolveSemanticColor(theme, 'warning'), 0.21);
  }
  return darken(resolveSemanticColor(theme, 'surfaceSubtle'), 0.12);
};
